import { LitElement, html, property } from 'lit-element';

import style from './fc-checkbox-scroll.css.js';
import '@forter/checkbox';
import { translate } from '@forter/directives';

/**
 * Provides a box with a search input and a scrollable div
 * with checkboxes derived from the given objects
 * @element fc-sort-control
 * @fires sort
 */
export class FcCheckboxScroll extends LitElement {
  /**
   * The objects to display
   * @type {Array}
   * @attr
   */
  @property({ type: Array }) objects;

  /**
   * The text inside the search box
   * @type {string}
   */
  @property({ type: String, reflect: true }) searchText = '';

  /** @inheritdoc */
  static is = 'fc-checkbox-scroll';

  /** @inheritdoc */
  static styles = [
    style,
  ];

  /**
   * Gets a keyup event and changes the search text
   * @param {String} value - The search value
   */
  onSearch({ target: { value } }) {
    this.searchText = value.toLowerCase();
  }

  /**
   * Triggered when a checkbox is checked/unchecked and sends an event to the user
   * @param {Event} event - The checkbox change event
   * @param {Object} obj - The object associated with the checkbox
   */
  onChange(event, obj) {
    const detail = { event, obj };
    this.dispatchEvent(new CustomEvent('change', { detail }));
  }

  /** @inheritdoc */
  render() {
    const { objects, searchText } = this;
    let array;
    if (searchText && searchText !== '') {
      array =
        [...objects].map(obj =>
          ({ obj, filtered: !obj.label.toLowerCase().includes(searchText) }));
    } else {
      array = [...objects].map(obj => ({ obj: obj }));
    }

    return html`
      <div>
        <forter-input
          class="search-input"
          left-icon="search"
          placeholder=${translate('SEARCH')}
          .value="${searchText}"
          tabindex="1"
          @keyup="${this.onSearch}">
        </forter-input>
      </div>
      
      <div class="filter-container options-filter-container">
        ${array.map(object => html`
          <forter-checkbox
            ?filtered="${object.filtered}"
            tabindex="${object.filtered ? -1 : 2}"
            ?checked="${object.obj.visible || object.obj.visible === undefined}"
            @change="${event => this.onChange(event, object.obj)}">
            <p slot="label">${object.obj.label}</p>
          </forter-checkbox>`)}
      </div>
    `;
  }
}
